import { render, staticRenderFns } from "./InsectSurvey.vue?vue&type=template&id=21daba1b&scoped=true"
import script from "./InsectSurvey.vue?vue&type=script&lang=js"
export * from "./InsectSurvey.vue?vue&type=script&lang=js"
import style0 from "./InsectSurvey.vue?vue&type=style&index=0&id=21daba1b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21daba1b",
  null
  
)

export default component.exports